import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { mapRefuelsToRows } from '../refuel-data-grid/mappers/refuelDataGridRows';
import { RefuelSummary } from '../refuel-summary/RefuelSummary';
import { RefuelDataGrid } from '../refuel-data-grid/RefuelDataGrid';

import type { RefuelsQueryResultProps } from '../../types/RefuelsQueryResultProps.types';

type RefuelResultPanelProps = Pick<RefuelsQueryResultProps, 'result' | 'isFetching'> & {
  isListView: boolean;
  exportFileName: string;
};

export function RefuelResultPanel({ result, isFetching, isListView, exportFileName }: RefuelResultPanelProps) {
  const { t } = useTranslation();
  const rows = useMemo(() => mapRefuelsToRows(result?.refuels, t), [result?.refuels, t]);
  const content = (
    <>
      <RefuelSummary result={result} />
      <RefuelDataGrid rows={rows} isListView={isListView} isFetching={isFetching} exportFileName={exportFileName} />
    </>
  );

  return isListView ? (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} data-qa-element-id="refuel_result_panel">
      {content}
    </Box>
  ) : (
    content
  );
}
